import AnimatedVacancies from './animatedVacancies';

new AnimatedVacancies().init();
